import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
//import { RootState } from '../store'

// eslint-disable-next-line compat/compat
// export const apiController = new AbortController()

export const apiSlice = createApi({
    reducerPath: 'api',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL,
        credentials: 'include',
        // signal: apiController.signal,
        //prepareHeaders: (headers, { getState }) => {
        //const token = (getState() as RootState).user.auth.token
        // If we have a token set in state, let's assume that we should be passing it.
        //if (token) {
        //	headers.set('authorization', `Bearer ${token}`)
        //}
        //return headers
        //},
    }),
    endpoints: () => ({}),
})
